import { Grid2 } from '@mui/material';
import { GiftCardsOverviewResult } from '../../types/gift-cards';
import ReportBox from '../reports/ReportBox';
import MetricCard from '../reports/MetricCard';

const GRID_ITEM_SIZE = {
  xs: 12,
  sm: 6,
  md: 4,
};

interface GiftCardsOverviewProps {
  overview: GiftCardsOverviewResult | undefined;
  isLoading?: boolean;
}

function GiftCardsOverview({ overview, isLoading }: GiftCardsOverviewProps) {
  return (
    <ReportBox isLoading={isLoading} type="regular">
      <Grid2
        container
        spacing={1}
        width="100%"
        columns={12}
        justifyContent="space-between">
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid">
          <MetricCard
            small
            metric={(overview?.activations ?? 0) / 100}
            name="Activations (last 30 days)"
            type="dollar"
            isLoading={isLoading}
          />
        </Grid2>
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid no-border">
          <MetricCard
            small
            metric={(overview?.redemptions ?? 0) / 100}
            name="Redemptions (last 30 days)"
            type="dollar"
            isLoading={isLoading}
          />
        </Grid2>
        <Grid2 size={GRID_ITEM_SIZE} className="metric-card-grid no-border">
          <MetricCard
            small
            metric={(overview?.outstanding ?? 0) / 100}
            name="Outstanding (all time)"
            type="dollar"
            isLoading={isLoading}
          />
        </Grid2>
      </Grid2>
    </ReportBox>
  );
}

export default GiftCardsOverview;
